// Vendors
import 'src/scripts/vendor/modernizr';
import 'src/scripts/vendor/jquery';
import 'src/scripts/vendor/gsap';

// Modules
import initPreloader from 'src/scripts/modules/preloader';
import initGeneral from 'src/scripts/modules/general';

document.addEventListener('DOMContentLoaded', () => {

  initPreloader();
  initGeneral();

});
